let s3URL = `//pcochef-static.s3.us-east-1.amazonaws.com`;

let scriptURL = `${s3URL}/plusapi/js/pcochef-plus.js`;

export { s3URL, scriptURL };
